<template>
  <el-collapse v-if="notices.length > 0" v-model="collapseConditions">
    <el-collapse-item title="お知らせ" name="1">
      <ul style="margin: 0px; list-style-type: none">
        <template v-for="(notice, idx) in notices">
          <li :key="idx">
            <el-popover
              placement="bottom-start"
              trigger="click"
              width="600"
            >
              <template>
                <pre>{{ notice.content }}</pre>
              </template>
              <el-link slot="reference" type="warning">{{ notice.title }}</el-link>
            </el-popover>
          </li>
        </template>
      </ul>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import api from '@/http/api.js'

export default {
  name: 'Notice',
  data: function () {
    return {
      notices: [],
      collapseConditions: ['1']
    }
  },
  mounted: async function () {
    this.notices = await api.notice.getEnableNotices()
  }
}
</script>
